import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { BusinessService } from "../../../types";
import { businessServiceService } from "../../../services/businessServiceService";

export const useCreateService = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      service,
      serviceMapId,
      dependencies,
      dependents,
    }: {
      serviceMapId: string;
      service: Omit<BusinessService, "status">;
      dependencies: string[];
      dependents: string[];
    }) => {
      const created = await businessServiceService.create(
        serviceMapId,
        service,
        dependencies,
        dependents,
      );
      return created;
    },
    onSuccess: ({ serviceMapId }) => {
      void qc.invalidateQueries({
        queryKey: ["serviceMapId", serviceMapId],
        exact: true,
      });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
